export default __webpack_public_path__ + "images/b72f1f8ad962d238f4f7a078b4eab4e4.svg";